<template>
	<transition name="modal">
		<div class="modal-mask" v-show="show">
			<div class="modal-container">
				<div class="modal-header">
					<h3>Editar Atendimento</h3>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-9">
							<div class="form-group">
								<label>Procedimento</label>
								<select-subgrupo :disableClear="true" :nome-subgrupo="$props.atendimento.contrato_subgrupo.subgrupo.nome" :contrato-id="$route.params.contratoId" @setSubgrupoSelecionado="(subgrupoSelecionado)=>{setSubgrupoSelecionado(subgrupoSelecionado)}"></select-subgrupo>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label>Sexo</label>
								<select class="form-control" v-model="$props.atendimento.sexo">
									<option value="0">Ambos</option>
									<option value="1">Masculino</option>
									<option value="2">Feminino</option>
								</select>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<label>Idade mínima</label>
								<input type="number" class="form-control" v-model="$props.atendimento.idade_minima">
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<label>Idade máxima</label>
								<input type="number" class="form-control" v-model="$props.atendimento.idade_maxima">
							</div>
						</div>
					</div>
					<div class="row">
							<div class="col-md-3">
								<div class="form-group">
									<label>Tipo Consumo</label>
									<select class="form-control" v-model="$props.atendimento.tipo_consumo">
										<option value="0">Por Procedimento</option>
										<option value="1">Por Paciente</option>
									</select>
								</div>
							</div>
						<div class="col-md-3">
							<div class="form-group">
								<label>Atendimentos</label>
								<input :disabled="$props.atendimento.tipo_consumo != 0" type="number" class="form-control" v-model="$props.atendimento.quantidade_atendimento">
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label>Local</label>
								<input :disabled="$props.atendimento.tipo_consumo != 0" type="number" class="form-control" v-model="$props.atendimento.quantidade_local">
							</div>
						</div>
						<div class="col-md-3">
								<div class="form-group">
									<label>Max. Pacientes</label>
									<input :disabled="$props.atendimento.tipo_consumo != 1" type="number" class="form-control" v-model="$props.atendimento.quantidade_paciente">
								</div>
							</div>
					</div>
					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<label>Hora inicial</label>
								<input type="time" class="form-control" v-model="$props.atendimento.hora_inicial">
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<label>Hora final</label>
								<input type="time" class="form-control" v-model="$props.atendimento.hora_final">
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<div class="text-right" style="float:right">
						<button class="btn btn-default" @click="$emit('close')">
									<i class="fa fa-close"></i> Fechar
								</button>
						<button @click="salvar()" class="btn btn-primary">
									<span class="fa fa-check"></span>
									Salvar
								</button>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	import axios from "axios"; // Cliente para requisição http
	import selectSubgrupo from "../contratos/selectSubgruposContrato";
	export default {
		props: ["show", "atendimento"],
		filters: {

		},
		data: () => ({

		}),
		mounted() {

		},
		methods: {
			salvar() {
				this.$swal({
					title: "Salvando, aguarde...",
					imageUrl: "/static/img/Rolling-green.gif",
					showConfirmButton: false,
					allowOutsideClick: false
				});
				axios.post(`${this.$store.state.serverURI}/api/administracao/agendas/updateSubgrupoAtendimento/${this.$props.atendimento.id}`, this.$props.atendimento, this.$store.getters.getHeaderAuth)
					.then(response => {
						this.$swal({
							type: "success",
							title: "Atendimento atualizado com sucesso!",
							showConfirmButton: false,
							timer: 1500
						});
						this.$emit("subgrupoAtendimentoAtualizado", this.$props.atendimento);
					}).catch((error) => {
						var erros = error.response.data.message + " ";
						for (var erro of Object.values(error.response.data.errors)) {
							erros += erro + " \n";
						}
						this.$swal({
							type: "error",
							title: "Houve uma falha!",
							text: erros
						});
						console.log(error);
					});
			}
		},
		watch: {

		},
		components: {
			selectSubgrupo
		}
	};
</script>

<style scoped>
	* {
		box-sizing: border-box;
	}

	.modal-mask {
		position: fixed;
		z-index: 1000;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		transition: opacity 0.3s ease;
	}

	.modal-container {
		width: 70%;
		margin: 40px auto 0;
		padding: 10px;
		background-color: #fff;
		border-radius: 2px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
		transition: all 0.3s ease;
		font-family: Helvetica, Arial, sans-serif;
	}

	.modal-header h3 {
		margin-top: 0;
		color: #333;
	}

	.modal-body {
		margin: 10px 0;
	}

	.text-right {
		text-align: right;
	}

	.form-label {
		display: block;
		margin-bottom: 1em;
	}

	.form-label>.form-control {
		margin-top: 0.5em;
	}

	.form-control {
		display: block;
		width: 100%;
		padding: 0.5em 1em;
		line-height: 1.5;
		border: 1px solid #ddd;
	}


	/*
			 * The following styles are auto-applied to elements with
			 * transition="modal" when their visibility is toggled
			 * by Vue.js.
			 *
			 * You can easily play with the modal transition by editing
			 * these styles.
			 */

	.modal-enter {
		opacity: 0;
	}

	.modal-leave-active {
		opacity: 0;
	}

	.modal-enter .modal-container,
	.modal-leave-active .modal-container {
		-webkit-transform: scale(1.1);
		transform: scale(1.1);
	}

	.modal {
		display: block !important;
		/* I added this to see the modal, you don't need this */
	}


	/* Important part */

	.modal-dialog {
		overflow-y: initial !important;
	}

	.modal-body {
		height: 350px;
		overflow-y: auto;
	}
</style>



// WEBPACK FOOTER //
// modalEditarSubgrupoAtendimento.vue?7cfa312e